import { API, CustomAxiosConfig } from './types'

export class MoveAPI {
  api: API

  constructor(api: API) {
    this.api = api
  }

  scan = async (data: any, config: CustomAxiosConfig = {}): Promise<null> => {
    await this.api.post('/logistics/scan/bulk-move', data, config)
    return null
  }
}
